<template>
  <el-container>
    <el-main style="padding: 0">
      <div class="mainBox departmentTree">
        <div class="treeMenu" :style="{ height: mainBoxHeight + 'px' }">
          <el-input v-model="filterText" placeholder="请输入部门名称"/>
          <el-tree
              ref="tree"
              :filter-node-method="filterNode"
              accordion
              class="filter-tree"
              :data="data"
              :highlight-current="true"
              node-key="id"
              @node-click="nodeClick"/>
        </div>
        <div class="treeContent">
          <view-table
              ref="viewTable"
              class="departmentTable"
              :filter="filter"
              :limits="limits"
              :columns-property="columnsProperty"
              module="basic"
              url="departments"
              @addOrEdit="addEditHandle"
              @select="selectHandle"
              @delete="deleteHandle"
              @reset="resetHandle">
            <template slot="otherBtn">
              <el-button v-if="(selection.length > 0 && limits.delAuth)" type="danger" @click="deleteBatch">批量删除</el-button>
            </template>
            <template slot="adSearch">
              <el-form :inline="true" :model="filter" @submit.native.prevent @keyup.enter.native="loadData(1)">
                <el-form-item label="查询：">
                  <el-input v-model.trim="filter.filter" placeholder="请输入关键字查询" clearable/>
                </el-form-item>
              </el-form>
            </template>
          </view-table>
          <!-- 编辑 -->
          <department-edit ref="editDepartment" @save-success="getDepartmentList()"/>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
  import ViewTable from "@/components/ViewTable.vue";
  import DepartmentEdit from "@/views/information/Department/DepartmentEdit";
  export default {
    name: "DepartmentList",
    components: {
      ViewTable,
      DepartmentEdit,
    },

    data() {
      return {
        limits:{
          addAuth: this.$auth(114),
          editAuth: this.$auth(115),
          delAuth: this.$auth(116),
        },
        columnsProperty:[
          {
            key:"departmentNO",
            align:"center",
          },
          {
            key:"outerNO",
            align:"center",
          },
          {
            key:"directorName",
            align:"center",
          },
          {
            key:"parentName",
            align:"center",
          },
          {
            key:"departmentName",
            align:"center",
          },
          {
            key:"telephone",
            align:"center",
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
        mainBoxHeight: 0,
        data: [],
        filterText: "",
        filter: {
          parentID: "",
          filter: "",
        },
        selection: [],
      };
    },

    // 监听部门关键字
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      },
    },

    created() {
      this.getDepartmentList();
    },

    mounted() {
      this.setMainBoxHeight();
      window.onresize = () => {
        this.setMainBoxHeight();
      };
    },

    methods: {
      // 动态设置mainBox的高度
      setMainBoxHeight() {
        var clientHeight = document.body.clientHeight;
        this.mainBoxHeight = clientHeight - 90;
      },

      // 查询部门树形列表
      getDepartmentList() {
        this.$http.get("basic", "departments/tree").then((res) => {
          if (res.success) {
            this.data = [{ id: 0, label: "全  部", parentId: 0, children: null }];
            this.data = this.data.concat(res.data);
            // 设置默认选中第一个节点
            this.$nextTick(() => {
              this.$refs.tree.setCurrentKey(0);
              this.filter.parentID = 0;
              this.loadData(1);
            });
          }
        });
      },

      // 根据关键字过滤
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },

      addEditHandle(row) {
        this.$refs.editDepartment.open(row);
      },

      loadData() {
        this.$refs.viewTable.loadData(1);
      },

      // 节点被点击时
      nodeClick(row) {
        this.filter.parentID = row.id;
        this.loadData(1);
        this.$refs.tree.setCurrentKey(row.id);
      },

      // 删除(单删)
      deleteHandle(row) {
        console.log(row);
        let ids = [];
        ids.push(row.departmentID);
        this.$http.delete("basic", "departments", ids).then((res) => {
          if (res.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      // checkBox
      selectHandle(selection) {
        this.selection = selection;
      },

      // 重置
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      // 批量删除部门
      deleteBatch() {
        var ids = [];
        this.selection.forEach((item) => {
          ids.push(item.departmentID);
        });
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.delete("basic", "departments/idList", ids).then((resp) => {
            if (resp.success) {
              this.getDepartmentList();
              this.$message.success("删除成功");
              this.selection = [];
            }
          });
        });
      },
    },
  };
</script>
<style scoped>
.mainBox {
  overflow: hidden;
}

.treeMenu {
  width: 200px;
  overflow-y: scroll;
  padding: 0 10px;
  margin-right: 10px;
  box-sizing: border-box;
  float: left;
}

.departmentTable {
  width: calc(100% - 210px);
  float: right;
}

.el-tree {
  margin-top: 10px;
}
</style>

<style>
.departmentTree .el-tree-node__label {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
